export default ({...props}) => {
  const {size, space, rem, unit} = props.theme
  return `
    & .MuiSkeleton-root {
      background-color: rgb(62 90 140 / 11%);
    }

    &[ap_type="app_footer_skeleton"] {
        display: flex;
        width: 100%;
        align-items: center;
        flex-flow: column;
        gap: ${space(2)}px;

        & > div{
          display: flex;
          justify-content: center;
          width: ${size(12.5)}%;
          gap: ${space(2)}px;
        }

        & .MuiSkeleton-root {
          width: ${size(2.5)}%;
          transform: scale(1);
          height: ${size(1.875)}px;

          @media screen and (max-width:480px){
            width: ${size(5)}%;
          }
        }
    }
    
    &[ap_type="order_details_skeleton"] {
      & > .MuiSkeleton-root:nth-child(1) {
        width: ${size(5)}%;
        height: ${rem(1.75)}
      }

      & > .MuiSkeleton-root:not(:first-child) {
          width: ${size(2.5)}%;
          height: ${rem(0.875)}
      }

      @media screen and (max-width:480px){
        & > .MuiSkeleton-root:nth-child(1) {
            width: ${size(12.5)}%;
        }

        & > .MuiSkeleton-root:not(:first-child) {
            width: ${size(10)}%;
        }
      }
    }

    &[ap_type="visit_card_skeleton"] {
      display: flex;
      flex-flow: column;
      gap: ${space(2)}px;
      
      & > .MuiSkeleton-root {
        height: ${size(37.5)}px;
        transform: scale(1);
      }
    }

    &[ap_type="best_date_skeleton"] {
      & > span.MuiSkeleton-root {
        height: ${size(40)}px;
        transform: scale(1);
      }
    }

    &[ap_type="login_header_skeleton"] {
      display: flex;
      flex-flow: column;
      gap: ${space(2)}px;

      & > span.MuiSkeleton-root {
        height: ${size(6.25)}px;
        transform: scale(1);
      }
    }

    &[ap_type="login_form_skeleton"] {
      display: flex;
      margin-top: ${space(3)}px;

      & > span.MuiSkeleton-root {
        width: ${size(12.5)}%;
        height: ${size(34)}px;
        transform: scale(1);
      }
    }

    &[ap_type="brand_app_content_area_skeleton"] {
      margin-bottom: ${space(2)}px;
      & > span.MuiSkeleton-root {
        width: ${size(7.5)}%;
        height: ${size(9.325)}px;
        transform: scale(1);
      }
    }

    &[ap_type="brand_app_bar_skeleton"] {
      & > span.MuiSkeleton-root {
        width: ${size(24.5)}px;
        height: ${size(3.75)}px;
        transform: scale(1);
        background-color: rgba(0,0,0,0.11);
      }
    }

    &[ap_type="edit_location_address_skeleton"] {
      display: flex;
      width: ${unit(100)}%;
      flex-flow: column;
      gap: ${space(1.25)}px;
      margin-top: ${space(1)}px;
      & > span.MuiSkeleton-root:nth-of-type(1) {
        width: ${unit(80)}%;
        height: ${size(1.5)}px;
        transform: scale(1);
      }
      & > span.MuiSkeleton-root:nth-of-type(2) {
        width: ${unit(60)}%;
        height: ${size(1.5)}px;
        transform: scale(1);
      }
    }
    `
}
